(function ($) {
    // Series buttons

    $('.m-filter__button').bind('click', function () {
        $('#filter_series').val($(this).attr('data-series'));
        $('#filter').submit();
    });

    // Active filter tab on page load

    let activeValue = $('#filter_active_tab').val();

    let activeCheckboxes = '#checkboxes_' + activeValue;
    $(activeCheckboxes).addClass('m-filter__content--isvisible');

    let activeTab = '#tab_' + activeValue;
    $(activeTab).addClass('m-filter__tab--isvisible');

    // Filter tabs

    $('.m-filter__tab button').bind('click', function () {
        $('.m-filter__content--isvisible').removeClass(
            'm-filter__content--isvisible'
        );
        $('.m-filter__tab--isvisible').removeClass('m-filter__tab--isvisible');
        $(this).parent().addClass('m-filter__tab--isvisible');
        let targetTab = '#' + $(this).attr('data-target');
        $(targetTab).addClass('m-filter__content--isvisible');
    });

    // Submit form when a checkbox is set
    $('.filter_term').change(function () {
        $('#filter_active_tab').val($(this).attr('data-tab'));
        $('#filter').submit();
    });

    // Toggles
    $('.m-filter__name a').bind('click', function (e) {
        target = $(this).attr('href');
        $(target).toggleClass('m-filter--isactive');
        e.preventDefault();
    });
})(jQuery);
